/**
 * TYPESENSE SEARCH CLIENT
 * Cliente para búsqueda con Typesense Cloud
 * Incluye typo tolerance, sinónimos y fallback automático
 */

class TypesenseSearchClient {
  constructor(config) {
    this.host = config.host;
    this.apiKey = config.apiKey;
    this.collection = config.collection || 'products';
    this.enabled = config.enabled !== false;
  }

  /**
   * Buscar productos en Typesense
   */
  async search(query, options = {}) {
    if (!this.enabled) {
      throw new Error('Typesense is disabled');
    }

    const params = new URLSearchParams({
      q: query,
      query_by: options.query_by || 'title,vendor,tags,product_type',
      per_page: options.per_page || 20,
      page: options.page || 1,
      
      // Typo tolerance (magia de Typesense)
      num_typos: options.num_typos || '2',
      typo_tokens_threshold: options.typo_tokens_threshold || '1',
      
      // Facets (filtros)
      facet_by: options.facet_by || 'vendor,product_type,price_range,available',
      max_facet_values: options.max_facet_values || '10',
      
      // Sorting
      sort_by: options.sort_by || '_text_match:desc,created_at:desc',
      
      // Highlight
      highlight_full_fields: options.highlight_full_fields || 'title',
      highlight_affix_num_tokens: options.highlight_affix_num_tokens || '4',
    });

    // Agregar filtros si existen
    if (options.filter_by) {
      params.append('filter_by', options.filter_by);
    }

    const url = `https://${this.host}/collections/${this.collection}/documents/search?${params.toString()}`;

    try {
      const response = await fetch(url, {
        headers: {
          'X-TYPESENSE-API-KEY': this.apiKey
        }
      });

      if (!response.ok) {
        throw new Error(`Typesense error: ${response.status}`);
      }

      const data = await response.json();
      return this.transformResults(data);

    } catch (error) {
      console.error('Typesense search error:', error);
      throw error;
    }
  }

  /**
   * Transformar resultados de Typesense a formato compatible con Shopify
   */
  transformResults(data) {
    const products = data.hits.map(hit => {
      const doc = hit.document;
      
      return {
        id: doc.id,
        title: doc.title,
        handle: doc.handle,
        vendor: doc.vendor,
        product_type: doc.product_type,
        price: doc.price,
        url: doc.url,
        image: doc.image,
        available: doc.available,
        inventory: doc.inventory,
        
        // Metadata de Typesense
        _score: hit.text_match_info?.score || 0,
        _highlights: hit.highlights || []
      };
    });

    return {
      products: products,
      found: data.found,
      page: data.page,
      facets: data.facet_counts || [],
      search_time_ms: data.search_time_ms
    };
  }

  /**
   * Health check
   */
  async ping() {
    try {
      const response = await fetch(`https://${this.host}/health`, {
        headers: {
          'X-TYPESENSE-API-KEY': this.apiKey
        }
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
}

// Exportar al global scope
window.TypesenseSearchClient = TypesenseSearchClient;
